import React from 'react';
import { FN110 } from '../../../services/pwn201Api';

interface Props {
  formData: FN110;
  isEditing: boolean;
  getField: (field: keyof FN110) => unknown;
  setField: (field: keyof FN110, value: unknown) => void;
}

const TabBasicInfo: React.FC<Props> = React.memo(({ formData, isEditing, getField, setField }) => {
  const dateToInput = (v: string | null) => (v ? v.substring(0, 10) : '');

  return (
    <div className="pwn201-form-grid">
      <label data-contract-field="fn110_01">客訴單號</label>
      <input value={(getField('fn110_01') as string) || ''} readOnly disabled className="readonly-field" />

      <label data-contract-field="fn110_11">入單日期</label>
      <input
        type="date"
        value={dateToInput(getField('fn110_11') as string | null)}
        onChange={(e) => setField('fn110_11', e.target.value ? e.target.value + 'T00:00:00Z' : null)}
        disabled={!isEditing}
      />

      <label data-contract-field="fn110_12">客戶代號</label>
      <input
        value={(getField('fn110_12') as string) || ''}
        onChange={(e) => setField('fn110_12', e.target.value)}
        disabled={!isEditing}
        maxLength={12}
        onDoubleClick={() => { /* TODO: open customer lookup PW1104F5 */ }}
        title="雙擊查詢客戶"
        style={{ cursor: isEditing ? 'pointer' : undefined }}
      />

      <label data-contract-field="fn110_131">業務人員</label>
      <input
        value={(getField('fn110_131') as string) || ''}
        onChange={(e) => setField('fn110_131', e.target.value)}
        disabled={!isEditing}
        maxLength={8}
        onDoubleClick={() => { /* TODO: open employee lookup PW9101F6 */ }}
        title="雙擊查詢業務人員"
        style={{ cursor: isEditing ? 'pointer' : undefined }}
      />

      <label data-contract-field="fn110_22">部門代號</label>
      <input
        value={(getField('fn110_22') as string) || ''}
        readOnly
        disabled
        className="readonly-field"
      />

      <label data-contract-field="fn110_14">幣別</label>
      <input
        value={(getField('fn110_14') as string) || ''}
        onChange={(e) => setField('fn110_14', e.target.value)}
        disabled={!isEditing}
      />

      <label data-contract-field="fn110_15">匯率</label>
      <input
        type="number"
        value={(getField('fn110_15') as number) || 0}
        onChange={(e) => setField('fn110_15', parseFloat(e.target.value) || 0)}
        disabled={!isEditing}
      />

      <label data-contract-field="fn110_16">外幣賠償金額</label>
      <input
        type="number"
        value={(getField('fn110_16') as number) || 0}
        onChange={(e) => setField('fn110_16', parseFloat(e.target.value) || 0)}
        disabled={!isEditing}
      />

      <label data-contract-field="fn110_17">台幣賠償金額</label>
      <input
        type="number"
        value={(getField('fn110_17') as number) || 0}
        readOnly
        disabled
        className="readonly-field"
        title="由處理要求明細自動計算"
      />

      <label data-contract-field="fn110_18">客訴數量</label>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        <input
          type="number"
          value={(getField('fn110_18') as number) || 0}
          onChange={(e) => setField('fn110_18', parseFloat(e.target.value) || 0)}
          disabled={!isEditing}
          style={{ flex: 1 }}
        />
        <span>/</span>
        <input
          value={(getField('fn110_19') as string) || ''}
          onChange={(e) => setField('fn110_19', e.target.value)}
          disabled={!isEditing}
          maxLength={3}
          placeholder="單位"
          style={{ width: 60 }}
        />
      </div>

      <label data-contract-field="fn110_29">
        <input
          type="checkbox"
          checked={(getField('fn110_29') as boolean) || false}
          onChange={(e) => setField('fn110_29', e.target.checked)}
          disabled={!isEditing}
        />
        &nbsp;訂單取消（無交運）
      </label>
      <span />

      <label data-contract-field="fn110_30">S/C NO.</label>
      <input
        value={(getField('fn110_30') as string) || ''}
        onChange={(e) => setField('fn110_30', e.target.value)}
        disabled={!isEditing || !formData.fn110_29}
        onDoubleClick={() => { /* TODO: open S/C lookup PWC202F6 */ }}
        title="雙擊查詢S/C"
        style={{ cursor: isEditing && formData.fn110_29 ? 'pointer' : undefined }}
      />

      <label data-contract-field="fn110_31">客訴說明</label>
      <textarea
        value={(getField('fn110_31') as string) || ''}
        onChange={(e) => setField('fn110_31', e.target.value)}
        disabled={!isEditing}
        rows={3}
        style={{ gridColumn: '2 / span 3' }}
      />

      <label data-contract-field="fn110_80">狀態</label>
      <input value={(getField('fn110_80') as string) || 'N'} readOnly disabled className="readonly-field" />

      <label data-contract-field="fn110_803">
        <input
          type="checkbox"
          checked={(getField('fn110_803') as boolean) || false}
          disabled
          readOnly
        />
        &nbsp;轉採購段
      </label>
      <span />
    </div>
  );
});

export default TabBasicInfo;
